import { Config } from "common/config"
import { EColors } from "common/styles"
import { Styled } from "components/Styled"
import { Fade } from "react-awesome-reveal"
import { Component } from "./components"
import { StyledKindFuelSection } from "./styled"

export const KindFuel = () => {
  return (
    <StyledKindFuelSection color={EColors.white} id={Config.Section.kindsGas}>
      <Styled.Container>
        <Fade direction="up" triggerOnce delay={800}>
          <Styled.H2>Види пального</Styled.H2>
          <Component.FuelListCard />
        </Fade>
      </Styled.Container>
    </StyledKindFuelSection >
  )
}